import api from '@/api'
import restaurants from './restaurants'
import taxInformation from './taxInformation'

export default {
  namespaced: true,

  modules: {
    restaurants,
    taxInformation
  },

  state: () => ({
    data: {
      name: '',
      _id: '',
      uuid: '',
      onboarded: null,
      extendLayout: null
    },
    loadingPropagate: false
  }),

  actions: {
    select: async function (ctx, provider) {
      await ctx.commit('set', provider)
      await ctx.commit('login/setRole', provider.role, { root: true })
      await ctx.commit('login/setPermissions', provider.permissions, { root: true })

      const restaurantsParams = {
        select: '_id name'
      }

      await ctx.dispatch('restaurants/get', restaurantsParams)
      ctx.dispatch('taxInformation/get')
      ctx.dispatch('subscribePropagateChannel')
    },

    detail: async function (ctx) {
      const response = await api.get(`/v1/providers/${ctx.state.data._id}`)
      await ctx.commit('set', response)
      ctx.dispatch('taxInformation/get')
    },

    reset: function (ctx) {
      ctx.commit('reset')
      ctx.commit('restaurants/reset')
      ctx.commit('taxInformation/reset')
    },

    subscribePropagateChannel: async function (ctx) {
      const channel = await this._vm.$pusher.subscribe(`${ctx.state.data._id}-channel`)

      channel.bind('propagate-notification', function (data) {
        ctx.commit('setLoading', false)
      })
    },

    unsubscribePropagateChannel: async function (ctx) {
      this._vm.$pusher.unsubscribe(`${ctx.state.data._id}-channel`)
    }
  },

  mutations: {
    set: function (state, provider) {
      const { name, _id, id, onboarded, extendLayout } = provider
      state.data = { name, _id, id, onboarded, extendLayout }
    },
    reset: function (state) {
      state.data = {
        name: '',
        _id: '',
        uuid: '',
        onboarded: null,
        extendLayout: null
      }
    },
    setLoading: function (state, val) {
      state.loadingPropagate = val
    }
  }
}
